<template>
	<select @change='change' v-model="selected" class='form-control my-control table-control'>
		<option v-for="option in options" :value='option.id'>
			{{ option.name }}
		</option>
	</select>
</template>

<script>
	import {DB} from './../../../constants'
	const FOREST_PURPOSE = 'get_forest_purpose.php'

	import {EventBus} from '../../../lib/EventBus'

	export default {
		name: 'forestPurpose',
		data: function () { 
			return {
				selected: '',
				options: []
			}
		},
		props: {
			line_count: 0,
			type: '',
			id: ''
		},
		methods: {
			change () {
				EventBus.$emit(`${this.type}_forest_purpose`, {index: this.line_count, value: this.selected})
			}
		},
		created: function () {
			fetch(DB + FOREST_PURPOSE, {
				credentials: 'include'
			})
			.then(data => data.json())
			.then(data => {
				if (data) {
					this.options = data
					this.selected = this.id ? this.id : data[0].id
					this.change()
				}
				else {
					this.options = []
				}
			})
			.catch(err => console.log(err))
		}
	}
</script>


// WEBPACK FOOTER //
// forestPurpose.vue?17f02b6b